<template>
  <div>
    <div ref="list">
      <el-table
        :data="users.filter(el=>!el.occupy)"
        style="width: 100%"
        :empty-text="$t('userList.notUser')">
        <el-table-column
          prop="userId"
          :label="$t('userList.id')"
          width="80">
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('userList.name')">
        </el-table-column>
        <el-table-column
          width="80"
          prop="occupy"
          align="center"
          :label="$t('userList.phone')">
          <template slot-scope="scope">
            <svg-icon icon-class="telephone" @click="openTel(scope.row)"
                      style="font-size:15px; color:#7dcf94; cursor: pointer;"></svg-icon>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showIM()"
          width="80"
          prop="occupy"
          align="center"
          :label="$t('userList.chat')">
          <template slot-scope="scope">
            <el-badge :is-dot="scope.row.unRead > 0" class="item">
              <svg-icon icon-class="im" @click="openIM(scope.row)"
                        style="font-size:18px; transform:translate(0px,-4px); color:#7dcf94; cursor: pointer;"></svg-icon>
            </el-badge>
          </template>
        </el-table-column>
        <el-table-column
          v-if="showIM()"
          width="80"
          prop="occupy"
          align="center"
          :label="`${$t('userList.chat')}(${$t('userList.new')})`">
          <template slot-scope="scope">
            <el-badge :data-c="scope.row.newUnRead" :is-dot="scope.row.newUnRead > 0" class="item">
              <svg-icon icon-class="im-new" @click="openChatIM(scope.row)"
                        style="font-size:18px; transform:translate(0px,-4px); color:#7dcf94; cursor: pointer;"></svg-icon>
            </el-badge>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserList',
  props: {
    users: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      refreshCurrent: false
    }
  },
  created: function () {
  },
  mounted () {
    this.init()
  },
  computed: {
    userLength () {
      return this.users === null ? 0 : this.users.length
    }
  },
  watch: {
    userLength (newV, oldV) {
      console.log('msg-change', newV, oldV)
      if (!this.refreshCurrent) {
        this.refreshCurrent = true
        this.$emit('refreshCurrentContact')
        this.refreshCurrent = false
      }
    }
  },
  methods: {
    init () {
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex % 2 !== 0) {
        return 'row1'
      } else if (rowIndex % 2 === 0) {
        return 'row2'
      }
      return ''
    },
    sortMonitorState (user1, user2) {
      if (user1.state === user2.state) {
        return 0
      } else if (user1.state > user2.state) {
        return -1
      } else {
        return 1
      }
    },
    showIM () {
      const userType = sessionStorage.getItem('service-user-type')
      if (userType) {
        return parseInt(userType, 10) === 2
      }
      return false
    },
    openIM (row) {
      this.$emit('rowClick', row)
    },
    openChatIM (row) {
      this.$emit('openChat', row)
    },
    openTel (row) {
      console.log('tel::1', row)
      this.$emit('openContact', row)
    }
  },
  destroyed () {
    if (this.scroller) {
      this.scroller.destroy()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::v-deep.el-table .row1 {
  background: #ffffff;
}

::v-deep.el-table .row2 {
  background: #ffffff;
}

::v-deep.el-table .el-table__cell {
  padding: 8px 0;
}

.item {
  margin-top: 10px;
}
</style>
